import { IConfig, IWritableConfig } from "./types";

interface IInternalConfig {
  tagNames: {
    route: string;
    router: string;
    outlet: string;
    layout: string;
    layoutOutlet: string;
    link: string;
    head: string;
    guardHandler: string;
  };
  enableShadowRoot: boolean;
  basenameFileExtensions: string[];
}

const _config: IInternalConfig = {
  tagNames: {
    route: "wcs-route",
    router: "wcs-router",
    outlet: "wcs-outlet",
    layout: "wcs-layout",
    layoutOutlet: "wcs-layout-outlet",
    link: "wcs-link",
    head: "wcs-head",
    guardHandler: "wcs-guard-handler"
  },
  enableShadowRoot: false,
  basenameFileExtensions: [".html"]
};

function deepFreeze<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") return obj;
  Object.freeze(obj);
  for (const key of Object.keys(obj)) {
    deepFreeze((obj as Record<string, unknown>)[key]);
  }
  return obj;
}

function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") return obj;
  const clone: Record<string, unknown> = {};
  for (const key of Object.keys(obj)) {
    clone[key] = deepClone((obj as Record<string, unknown>)[key]);
  }
  return clone as T;
}

let frozenConfig: IConfig | null = null;

// 後方互換のため config もエクスポート（読み取り専用として使用）
export const config: IConfig = _config as IConfig;

export function getConfig(): IConfig {
  if (!frozenConfig) {
    frozenConfig = deepFreeze(deepClone(_config));
  }
  return frozenConfig;
}

export function setConfig(partialConfig: IWritableConfig): void {
  if (partialConfig.tagNames) {
    Object.assign(_config.tagNames, partialConfig.tagNames);
  }
  if (typeof partialConfig.enableShadowRoot === "boolean") {
    _config.enableShadowRoot = partialConfig.enableShadowRoot;
  }
  if (Array.isArray(partialConfig.basenameFileExtensions)) {
    _config.basenameFileExtensions = partialConfig.basenameFileExtensions;
  }
  frozenConfig = null;
}
